import { initFadeIn, initParallax } from "./components/animations";
import { triggerHeaderScroll } from "./components/observers";
import AOS from "aos";

AOS.init({
  duration: 500, // values from 0 to 3000, with step 50ms
  once: true,
});

function openMenu() {
  function init() {
    const btn = document.querySelector(".mobile-menu-btn");
    const menu = document.querySelector(".mobile-menu-wrap");

    const menuItems = document.querySelectorAll(".primary-nav-mobile a");

    btn.addEventListener("click", () => {
      btn.classList.toggle("active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });

    const innerCTA = document.querySelector(".mobile-menu-wrap .btn-primary");

    innerCTA.addEventListener("click", () => {
      btn.click();
    });

    menuItems.forEach((item) => {
      item.addEventListener("click", () => {
        btn.click();
      });
    });
  }

  const isPresent = document.getElementsByClassName("mobile-menu-btn");
  if (isPresent.length > 0) {
    init();
  }
}

initFadeIn();

function runOnLoadAndDocumentReady() {
  openMenu();
  triggerHeaderScroll();

  // run this function only above 768px screen with
  if (window.innerWidth > 768) {
    // initParallax();
  }
}

if (document.readyState !== "loading") {
  runOnLoadAndDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    runOnLoadAndDocumentReady();
  });
}
